import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { EventNewComponent } from '../event-new/event-new.component';
import { ApiService } from "src/app/services/api.service";
import { SessionService } from "src/app/services/session.service";
import { EventDialogComponent } from "../event-dialog/event-dialog.component";


interface Event {
  event_log_key: number;
  event_created_by: string; 
  event_created_dt: string | null;
  description: string;  
  reminder: string | null;
  start_time: string; // HH:mm format
  end_time: string; // HH:mm format
  start_date: string; // YYYY-MM-DD format
  end_date: string; // YYYY-MM-DD format
  event_name: string;
  type: string;
}
interface Events {
  time: string;
  name: string;
  type?: string;
  color: string;
}

interface CalendarDay {
  date: Date | any;
  isCurrentMonth: boolean;
  events: Event[];
}

@Component({
  selector: 'app-side-calendar',
  templateUrl: './event-calendar.component.html',
  styleUrls: ['./event-calendar.component.scss']
})
export class EventCalendarComponent implements OnInit {
  groupedEvents: { [key: string]: Event[] } = {};
  currentView:any = 'list'; //'list' | 'calendar' = 'list';
  currentDate: Date = new Date();
  currentMonth: string = '';
  currentYear: number = 0;
  calendarDays: CalendarDay[] = [];
  dayNames: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  selectedDay: CalendarDay | null = null;
  selectedDate: moment.Moment = moment();
  days: moment.Moment[] = [];
  formattedDate: string = '';
  events: Events[] = [];
  viewDate: Date = new Date();
  username: any;
  calendarOptions: any;
  timeSlots: string[] = [];
  listEvent:Event[] = [];
  isloading:boolean = true;
  public object:any = Object;
  sortAsc: boolean = true;

  constructor(private datePipe: DatePipe,private dialog:MatDialog ,private apiService: ApiService,private sessionService: SessionService) {
    this.username = this.sessionService.getUsernameLocal();
  }

  ngOnInit(): void {
    // In a real app, you would fetch this from a service
      let postData: any = {
        brand_key: 200101,
        user_email: this.username,
      };
      this.apiService.getAllEvent(postData).subscribe((res: any) => {
        this.events = res
        this.listEvent = res;
        this.groupEventsByDate(this.events);
        this.isloading = false;
      });
     
    // this.generateCalendar();
    this.generateWeek();
    this.updateFormattedDate();
    // this.generateTimeSlots();
       
  }

  groupEventsByDayAndHour(events: Event[]): { [date: string]: { [hour: string]: Event[] } } {
    return events.reduce((acc, event) => {
      const date = event.start_date;
      const hour = this.getHour(event.start_time);
  
      if (!acc[date]) acc[date] = {};
      if (!acc[date][hour]) acc[date][hour] = [];
  
      acc[date][hour].push(event);
      return acc;
    }, {} as { [date: string]: { [hour: string]: Event[] } });
  }
  
  getHour(time: string): string {
    const match = time.match(/(\d+):(\d+)\s?(AM|PM)/);
    if (!match) return '0';
  
    let hour = parseInt(match[1], 10);
    const isPM = match[3] === 'PM';
  
    if (isPM && hour !== 12) hour += 12;
    if (!isPM && hour === 12) hour = 0;
  
    return hour.toString();}


  groupEventsByDate(events:any): void {
    this.groupedEvents = events.reduce((acc:any, event:any) => {
      if (!acc[event.start_date]) {
        acc[event.start_date] = [];
      }
      acc[event.start_date].push(event);
      return acc;
    }, {} as { [key: string]: Event[] });
    // console.log(this.groupedEvents);
    
  }



  getDayName(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'MMMM d, y') || '';
  }

  formatFullDate(date: Date): string {
    return this.datePipe.transform(date, 'EEEE, MMMM d, y') || '';
  }

  formatDateForKey(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
  }
  generateWeek() {
    this.days = [];
    let startOfWeek = this.selectedDate.clone().startOf('week');
    for (let i = 0; i < 7; i++) {
      this.days.push(startOfWeek.clone().add(i, 'days'));
    }
  }

  selectDate(day: moment.Moment) {
    this.selectedDate = day;
    this.updateFormattedDate();
  }

  prevDate() {
    this.selectedDate = this.selectedDate.clone().subtract(1, 'day');
    this.generateWeek();
    this.updateFormattedDate();
 }

  nextDate() {
    this.selectedDate = this.selectedDate.clone().add(1, 'day');
    this.generateWeek();
    this.updateFormattedDate();
 }

  updateFormattedDate() {
    this.formattedDate = this.selectedDate.format('DD MMMM YYYY | dddd');
  }
 addEvent() {
    this.dialog.open(EventNewComponent, {
        data: {},
        width: "450px",
        height: "auto",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        // Call your API to refresh the events
        if (!result) return;
        const postData: any = {
          brand_key: 200101,
          user_email: this.username,
        };

        this.apiService.getAllEvent(postData).subscribe((res: any) => {
          this.events = res;
        });
      });
  }

  // generateTimeSlots() {
  //   const slots: string[] = [];
  //   for (let h = 0; h < 24; h++) {
  //     slots.push(`${this.pad(h)}:00`);
  //     slots.push(`${this.pad(h)}:30`);
  //   }
  //   this.timeSlots = slots;
  // }

  // pad(num: number) {
  //   return num < 10 ? '0' + num : num.toString();
  // }

  // getEventsAtTime(time: string): any {
  //   return this.listEvent.filter((e:any) => moment(e.start_date).format('YYYY-MM-DD') === moment(this.selectedDate).format('YYYY-MM-DD') && e.start_time === time);
  // }

  // getTopOffset(event: Event): number {
  //   const [h, m] = event.start_time.split(':').map(Number);
  //   return (h * 2 + (m === 30 ? 1 : 0)) * (100 / 48);
  // }

  // getEventHeight(event: Event): number {
  //   const [sh, sm] = event.start_time.split(':').map(Number);
  //   const [eh, em] = event.end_time.split(':').map(Number);
  //   const duration = (eh * 60 + em) - (sh * 60 + sm);
  //   return (duration / 30) * (100 / 48);
  // }
  readonly SLOT_HEIGHT = 40;
  readonly INTERVAL_MINUTES = 30;
  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  generateTimeSlots(): string[] {
    const slots: string[] = [];
    for (let h = 0; h < 24; h++) {
      slots.push(`${this.pad(h)}:00`);
      slots.push(`${this.pad(h)}:30`);
    }
    return slots;
  }

  getEventsForDay():any{
    return this.listEvent.filter((e:any) => moment(e.start_date).format('YYYY-MM-DD') === moment(this.selectedDate).format('YYYY-MM-DD') );
  }

  getMinutesSinceMidnight(time: string): number {
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  }

  getTopOffset(time: string): number {
    return this.getMinutesSinceMidnight(time) / this.INTERVAL_MINUTES * this.SLOT_HEIGHT;
  }

  getEventHeight(start: string, end: string): number {
    const diff = this.getMinutesSinceMidnight(end) - this.getMinutesSinceMidnight(start);
    return (diff / this.INTERVAL_MINUTES) * this.SLOT_HEIGHT;
  }

  getGroupedEvents(): Event[][] {
    const sorted = this.getEventsForDay().sort((a:any, b:any) =>
      this.getMinutesSinceMidnight(a.start_time) - this.getMinutesSinceMidnight(b.start_time)
    );

    const groups: Event[][] = [];
    let currentGroup: Event[] = [];

    sorted.forEach((event:any) => {
      if (
        currentGroup.length === 0 ||
        this.getMinutesSinceMidnight(event.start_time) < this.getMinutesSinceMidnight(currentGroup[currentGroup.length - 1].end_time)
      ) {
        currentGroup.push(event);
      } else {
        groups.push(currentGroup);
        currentGroup = [event];
      }
    });

    if (currentGroup.length > 0) groups.push(currentGroup);
    return groups;
  }

  onEventClick(event: Event): void {
   this.dialog.open(EventDialogComponent, {
      data: this.transformEvent(event),
      width: "500px",
      height: "auto",
      disableClose: true,
    }).afterClosed()
    .subscribe((result:any) => {
      // Call your API to refresh the events
      if(result.status=='rejected'){
        this.events = this.events.filter((e:any) => e.id !== result.id);
        this.calendarOptions.events = [...this.events];
      }
      
    });
  }
  lastClickTime: number = 0;
  openEventDetails(event: Event) {
    // Create a shallow copy of extendedProps
    const now = Date.now();
    // Prevent double click within 300ms
    if (now - this.lastClickTime < 800) {
      return;
    }
    this.lastClickTime = now;
    let eventValue: any = event;

    this.apiService
      .getAllAttendees({ event_log_key: event.event_log_key, brand_key: 200101 })
      .subscribe((res: any) => {
        eventValue["participants"] = res;
        this.onEventClick(eventValue);
      });
  }
  transformEvent(rawEvent: any): any {
    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const formatDate = (dateStr: string) => {
      const date = new Date(dateStr);
      return `${date.getDate()} ${
        monthNames[date.getMonth()]
      } ${date.getFullYear()} (${dayNames[date.getDay()]})`;
    };

    const formatTime = (time: string) => {
      const [hour, minute] = time.split(":").map(Number);
      const suffix = hour >= 12 ? "PM" : "AM";
      const hour12 = hour % 12 || 12;
      return `${hour12.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")} ${suffix}`;
    };

    const calculateDuration = (startTime: string, endTime: string) => {
      const [sh, sm] = startTime.split(":").map(Number);
      const [eh, em] = endTime.split(":").map(Number);
      const durationMinutes = eh * 60 + em - (sh * 60 + sm);
      return `${durationMinutes} Min`;
    };

    const dedupedEmails = Array.from(
      new Set(
        (rawEvent.participants )
          .map((p: any) => p)
          .filter((email: any) => email.event_attendees_email !== rawEvent.event_created_by) // ✅ exclude creator
      )
    );
    // const attendee = rawEvent.participants.find((d: any) => d.event_attendees_email === this.username);
    const event_attendees = [
      {
        name: rawEvent.event_created_by
          .split("@")[0]
          .replace(".", " ")
          .replace(/\b\w/g, (c: any) => c.toUpperCase()),
        role: "Organizer",
        status: "",
        isYou: true,
        roleColor: "#007aff",
        email: rawEvent.event_created_by,
      },
      ...dedupedEmails.map((email: any) => ({
        name: email.event_attendees_email
          .split("@")[0]
          .replace(".", " ")
          .replace(/\b\w/g, (c:any) => c.toUpperCase()),
        role: "Attendee",
        status: email.event_attendee_status || "Invited",
        isYou: false,
        roleColor: "#5e5ce6",
        email,
      })),
    ];

    return {
      title: rawEvent.event_name,
      subtitle: rawEvent.type,
      date: formatDate(rawEvent.start_date),
      time: `${formatTime(rawEvent.start_time)} - ${formatTime(
        rawEvent.end_time
      )}`,
      duration: calculateDuration(rawEvent.start_time, rawEvent.end_time),
      event_attendees,
      meetingLink:
        rawEvent?.meeting_link || "https://meet.google.com/rtey-dsas-mtpqr",
      description: rawEvent.description,
      createdBy: rawEvent.event_created_by,
      event_log_key: rawEvent.event_log_key,
      diaplayActions:false,
      invitedBy: rawEvent.event_created_by
        .split("@")[0]
        .replace(".", " ")
        .replace(/\b\w/g, (c: any) => c.toUpperCase()),
    };
  }
  eventSort() {
    // for (const [key, events] of Object.entries(this.groupedEvents)) {
    //   events.sort((a: any, b: any) => {
    //     const dateA = new Date(a.start_date).getTime();
    //     const dateB = new Date(b.start_date).getTime();
    //     return this.sortAsc ? dateA - dateB : dateB - dateA;
    //   });
    // }
  
    this.sortAsc = !this.sortAsc;
  }
  
}
  
  